export const UNIQ_STAMP = 'qp7A48bWvh0cIUTOJ5djI4hwphWv57LaIfJUZI8zNrmgJrx4HMl6MOeRu2OLpDCO'
export const COLON_STAMP = 'A9fD3kQ7sP1mZ4tB8vC2hR6xN0yL5gU3wE7rT9pJ1dM4cH8bK2'

export function cutByUniqStamp(str) {
  if (!str) return str

  const idx = str.lastIndexOf(UNIQ_STAMP)
  const base = idx === -1 ? str : str.slice(0, idx)

  return base.replace(new RegExp(COLON_STAMP, 'g'), ':')
}

export function buildUniqueId(address, blockchainKey) {
  if (!address) return address

  const safeAddress = address.replace(/:/g, COLON_STAMP)
  // const marker = `${UNIQ_STAMP}${blockchainKey}`

  if (safeAddress.includes(UNIQ_STAMP)) return safeAddress

  return `${safeAddress}${UNIQ_STAMP}${blockchainKey}`
}